import React, { PropsWithChildren } from 'react';
import { ThemeProvider } from '@mui/material';
import theme from './theme';

export function ThemedComponent({ children }: PropsWithChildren): React.JSX.Element {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default ThemedComponent;
